export function values(parameters) {
  return {
    values: parameters.join(', ')
  };
}
